import { IconComponent } from './types';

const FarmDataIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      d="M7.7 0v2.126a4.905 4.905 0 0 1 3.864 6.639l1.82 1.074C13.776 8.969 14 8 14 6.982 14 3.347 11.235.351 7.7 0ZM7 11.895a4.903 4.903 0 0 1-4.9-4.913 4.905 4.905 0 0 1 4.2-4.856V0A7.004 7.004 0 0 0 0 6.982C0 10.856 3.129 14 6.993 14a6.977 6.977 0 0 0 5.642-2.87l-1.82-1.074A4.861 4.861 0 0 1 7 11.895Z"
      fill="var(--overyield-orange)"
    />
  </svg>
);

export default FarmDataIcon;
